import type { AgentOptions } from './agentBase';
import { AgentBase } from './agentBase';

export interface BotBaseOptions extends AgentOptions {
	autoAdvanceRound?: boolean;
}

export abstract class BotBase extends AgentBase {
	protected autoAdvanceRound: boolean;

	constructor(options: BotBaseOptions) {
		const { autoAdvanceRound, ...restOptions } = options;
		super(restOptions);
		this.autoAdvanceRound = autoAdvanceRound ?? false;
		this._isBot = true;
	}
}
